"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolHistoryTypeEnum = void 0;
var SymbolHistoryTypeEnum;
(function (SymbolHistoryTypeEnum) {
    SymbolHistoryTypeEnum["Realtime"] = "realtime";
    SymbolHistoryTypeEnum["Closed"] = "closed";
})(SymbolHistoryTypeEnum = exports.SymbolHistoryTypeEnum || (exports.SymbolHistoryTypeEnum = {}));
//# sourceMappingURL=symbol-history-type-enum.js.map